module.exports = __webpack_public_path__ + "static/media/search-glass.b463d181.jpg";